import documentReady from 'packs/helpers/documentReady';

const handleClick = async (e: Event, bookingInfoPath: string): Promise<void> => {
  const checkIn = (document.getElementById('check_in') as HTMLInputElement).value;
  const checkOut = (document.getElementById('check_out') as HTMLInputElement).value;
  const infoElement = document.querySelector('.contactForm-bookingInfo');
  infoElement.innerHTML = '';
  const target = e.target as HTMLButtonElement;
  target.disabled = true;
  const response = await fetch(`${bookingInfoPath}?start_date=${checkIn}&end_date=${checkOut}`);
  target.disabled = false;
  const bookingInfo = await response.text();
  infoElement.innerHTML = bookingInfo;
};

const addEventListener = (): void => {
  const contactForm = document.querySelector('.contactForm') as HTMLElement;
  if (!contactForm) return;

  const { bookingInfoPath } = contactForm.dataset;
  if (!bookingInfoPath) return;

  document.getElementById('getBookingInfo').addEventListener('click', (e) => handleClick(e, bookingInfoPath));
};

documentReady(addEventListener);
